export default __webpack_public_path__ + "./assets/img/icon_menu.svg";